export default "__VITE_PUBLIC_ASSET__f3526c69__"